<template>
<div>
    <div class="d-flex flex-row justify-content-center gap-3 mb-8">
        <div class="text-center">
            <h2 class="mb-0"> {{ __('statistics.listings.title') }} </h2>
            <h2 class="mt-3" v-if="initFilters.category">{{ __('statistics.in_category', {'category': this.initFilters.category}) }}</h2>
        </div>
        <Tooltip class="w-300px" position="left">
            <template #trigger>
                <i class="text-primary cursor-pointer fas fa-info-circle fa-lg"/>
            </template>
            <div v-html="listingsInfo"/>
        </Tooltip>
    </div>
    <ListingRecommendationsTable
        :statistics="statistics.MC[$page.props.store.id]"
        :category="initFilters.category"
        @reloadStats="fetchData">
    </ListingRecommendationsTable>
</div>
</template>

<script>
import StatisticsLayout from '@layouts/Statistics/StatisticsLayout.vue';
import ListingRecommendationsTable from '@components/Stats/Components/ListingRecommendationsTable.vue';
import Tooltip from '@components/Tooltip.vue';

export default {
    components: {Tooltip, ListingRecommendationsTable},
    layout: StatisticsLayout,

    props: {
        statistics: Object,
        initFilters: Object,
    },

    methods: {
        fetchData() {
            this.$inertia.reload({only: ['initFilters', 'statistics']});
        },
    },

    computed: {
        listingsInfo() {
            return this.__('statistics.listings.info');
        }
    }
};
</script>
